import Main from './Main'
import Lista from './components/Patentes'
import Novo from './components/NovaPatente'

export default [
  {
    path: 'patentes',
    name: 'config.patentes',
    component: Main,
    redirect: { name: 'config.patentes.list' },
    children: [
      {
        path: '/',
        name: 'config.patentes.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.patentes.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.patentes.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/policiais/patentes/routes.js